import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import TournamentsPage from './pages/tournaments/TournamentsPage';
import TournamentDetailPage from './pages/tournaments/TournamentDetailPage';
import RankingPage from './pages/ranking/RankingPage';
import NewsEditionPage from './pages/news/NewsEditionPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/tournaments' element={<TournamentsPage></TournamentsPage>} />
      <Route path='/tournaments/:torId' element={<TournamentDetailPage />} />
      <Route path='/ranking' element={<RankingPage></RankingPage>} />
      <Route path='/news' element={<NewsEditionPage></NewsEditionPage>} />
      <Route path='/config' element={<h1>Config Page</h1>} />
    </Routes>
  );
};

export default AppRoutes;
